import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzRateModule } from 'ng-zorro-antd/rate';
import { NzSegmentedModule } from 'ng-zorro-antd/segmented';
import { Session } from '../../../core/session/session';
import { SessionService } from '../../../core/session/session.service';

@Component({
  selector: 'app-session-survey',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,

    NzIconModule,
    NzButtonModule,
    NzModalModule,
    NzRateModule,
    NzSegmentedModule,
    NzInputModule,
  ],
  templateUrl: './session-survey.component.html',
  styleUrl: './session-survey.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SessionSurveyComponent {
  @Input() isVisible = false;
  @Output() isVisibleChange = new EventEmitter<boolean>();

  @Input({ required: true }) session!: Session;

  @Input() isClosable = false;

  rateList = Array.from({ length: 5 }, (_, i) => i + 1);
  rate: number | undefined = undefined;

  feedback: string | undefined = undefined;

  constructor(
    private sessionService: SessionService,
    private router: Router
  ) {}

  onOnInit() {
    // posthog.capture('survey shown', {
    //   $survey_id: environment.posthogSurvey.sessionEndSurvey,
    // });
  }

  handleCancel() {
    this.isVisible = false;
    this.isVisibleChange.emit(this.isVisible);
  }

  handleOk() {
    // posthog.capture('survey sent', {
    //   $survey_id: environment.posthogSurvey.sessionEndSurvey,
    //   $survey_response: `${this.rate}`,
    //   $survey_response_1: this.feedback ?? '',
    // });

    this.router.navigate(['', 'simulated-meetings', this.session!.id]);

    this.isVisible = false;
    this.isVisibleChange.emit(this.isVisible);
  }
}
